import React, { useEffect, useMemo, useState } from 'react'
import { getStatusCounts, getTabsFromSubtasks } from '../../../../utils/taskUtils';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSingleTask } from '../../../../redux/TaskReducer/action';
import './SubtaskVerification.css';
import { SubtaskRenderer } from './SubtaskScreens/SubtaskRenderer';

const SubtaskVerification = () => {
  
  const { singleTask } = useSelector((store) => {
    return {
      singleTask: store.TasksReducer.singleTask
    }
  });

  const subTasks = useMemo(() => singleTask?.data?.sub_tasks || [], [singleTask?.data]);

  const { taskId, activeTab } = useParams();
  const dispatch = useDispatch();

  const tabs = useMemo(() => getTabsFromSubtasks(subTasks), [subTasks]);
  // const [activeTab, setActiveTab] = useState(null);

  // const counts = useMemo(
  //   () => getStatusCounts(subTasks),
  //   [subTasks]
  // );

  const visibleSubtasks = useMemo(
    () =>
      subTasks.filter(
        st => st.task_type.type_code === activeTab
      ),
    [subTasks, activeTab]
  );

  // useEffect(() => {
  //   if (tabs.length && !activeTab) {
  //     setActiveTab(tabs[0].code);
  //   }
  // }, [tabs, activeTab]);

  useEffect(() => {
    dispatch(getSingleTask(taskId));
  }, [taskId, dispatch]);

  if(subTasks.length === 0){
    return (
      <div 
        style={{
          width: "100%",
          height: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "white",
          borderRadius: "20px",
          marginTop: "10px"
        }}
      >
        <p>No subtasks found</p>
      </div>
    )
  }

  return (
    <div className='subtask-container'>
      {/* Tabs */}
      {/* <div className="subtask-tabs">
        <div className="tabs">
          {tabs.map(tab => (
            <button
              key={tab.code}
              className={`tab ${activeTab === tab.code ? "active" : ""}`}
              onClick={() => setActiveTab(tab.code)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="status-summary">
          <span>Pending: {counts.pending}</span>
          <span className="approved">Approved: {counts.approved}</span>
          <span className="rejected">Rejected: {counts.rejected}</span>
        </div>
      </div> */}

      {/* Content */}
      <div className="subtask-content">
        {visibleSubtasks?.map(st => (
          <SubtaskRenderer key={st.sub_task_id} subtask={st} />
        ))}
      </div>
    </div>
  );
}

export default SubtaskVerification